import { useState, useEffect } from "react";
import apiFetch from "../services/apiClient";

/**
 * Devuelve el estado de configuración de las relaciones del catálogo.
 * faltantes: array de { campo, label } que aún no tienen cuenta configurada.
 */
export function useRelacionesCatalogo() {
  const [faltantes, setFaltantes] = useState([]);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    apiFetch("/api/core/relaciones-catalogo/")
      .then(r => r.json())
      .then(data => {
        const LABELS = {
          rel_cuenta_bancos:            "Bancos",
          rel_cuenta_cxc_filial:        "CxC Filiales",
          rel_cuenta_adelantado_filial: "Saldo a Favor Filiales",
          rel_cuenta_proveedores:       "Proveedores",
          rel_cuenta_iva_pagar:         "IVA por Pagar",
          rel_cuenta_iva_favor:         "IVA a Favor",
        };
        const sin = Object.entries(LABELS)
          .filter(([campo]) => !data.relaciones?.[campo]?.cuenta_actual)
          .map(([campo, label]) => ({ campo, label }));
        setFaltantes(sin);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  // Devuelve true si alguna de las relaciones indicadas está sin configurar.
  function faltanCampos(campos = []) {
    return faltantes.some((f) => campos.includes(f.campo));
  }

  return {
    faltantes,
    loading,
    todoConfigurado: faltantes.length === 0,
    faltanCampos,
  };
}
